module.exports = __webpack_public_path__ + "img/permit.bc69c99a.svg";